import { createCancelable } from "app/pages/workspace/sales/helpers";
import type { IFetchService } from "app/services/fetchService";

import type {
    IAccountSearch,
    ISavedSearchWebhook,
    ISavedSearchWebhookPayload,
    ITestWebhookRequest,
    ITestWebhookResponse,
} from "../types/webhook";

const BASE_URL = "/sales-api/save-search/webhooks";

export type SavedSearchWebhooksServiceType = {
    getSavedSearchWebhooks(p: { cancellation: AbortSignal }): Promise<ISavedSearchWebhook[]>;
    getAccountSearches(p: { cancellation: AbortSignal }): Promise<IAccountSearch[]>;
    createOrUpdateSavedSearchWebhook(payload: ISavedSearchWebhookPayload): Promise<ISavedSearchWebhook>;
    deleteSavedSearchWebhook(webhookId: string): Promise<void>;
    testSavedSearchWebhookUrl(payload: ITestWebhookRequest): Promise<ITestWebhookResponse>;
};

export const createSavedSearchWebhooksService = (
    fetchService: IFetchService,
): SavedSearchWebhooksServiceType => ({
    getSavedSearchWebhooks: createCancelable((cancellation: AbortSignal): Promise<ISavedSearchWebhook[]> => {
        return fetchService.get(BASE_URL, undefined, { cancellation });
    }),
    getAccountSearches: createCancelable((cancellation: AbortSignal): Promise<IAccountSearch[]> => {
        return fetchService.get(`${BASE_URL}/account-searches`, undefined, { cancellation });
    }),
    createOrUpdateSavedSearchWebhook: (payload: ISavedSearchWebhookPayload): Promise<ISavedSearchWebhook> => {
        return fetchService.post(BASE_URL, payload);
    },
    deleteSavedSearchWebhook: (webhookId: string): Promise<void> => {
        return fetchService.delete(`${BASE_URL}/${webhookId}`);
    },
    testSavedSearchWebhookUrl: (payload: ITestWebhookRequest): Promise<ITestWebhookResponse> => {
        return fetchService.post(`${BASE_URL}/test`, payload);
    },
});
